import styled from 'styled-components';

export const ControlSelectView = styled.div`
    width: 200px;
    display: inline-block;
`;

export const ControlSelectViewLabel = styled.div`
    padding: 0 13px;
    margin-bottom: 2px;
`;
